import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { PasswordChange } from './password-change';

@Injectable({
    providedIn: 'root'
})
export class PasswordRecoveryService {
    constructor(protected httpClient: HttpClient) {
    }
    private urlEndpoint =  environment.apiUrl + '/api/v2/password';

    recoverPw(idOrEmail: string) {
        return this.httpClient
          .get(`${this.urlEndpoint}/recover?recoverid=${idOrEmail}`, {observe: 'response', responseType: 'text'});
    }

    resetPw(passwordChange: PasswordChange): Observable<any>  {
        return this.httpClient
          .put<any>(`${this.urlEndpoint}/recover`, passwordChange);
    }

    change(passwordChange: PasswordChange): Observable<any>  {
        return this.httpClient
          .put<any>(`${this.urlEndpoint}/change`, passwordChange);
    }

}
